import Button from '../button/button';
import './sub-header-doc.scss';

const SubHeaderDoc = () => {
    return (
        <section>
            <div className="top-content">
                <div className="left-content"><a href="#">Forms / </a>Add Custom Field</div>
                <div className="right-content">
                    <div className="actions">
                        <Button className='' variant='middle'>Action</Button>
                    </div>
                    <div className="show-preview">
                        <Button className='' variant='middle'>Show Preview</Button>
                    </div>
                    <div className="update"><Button className='' variant='contained'>Update</Button></div>  
                </div>  
            </div>
        </section>
    );
}

export { SubHeaderDoc };
export default SubHeaderDoc;